class Fetcher {
  createPipe(config) {
    return {};
  }
  fetch(config) {
    return new Promise((resolve, reject) => {
      const pipe = this.createPipe(config);
      Promise.resolve().then(() => {
        this.before(config, pipe);
        config?.before?.();
      }).then(() => {
        return this.execute(config);
      }).then((data) => {
        const hasError = config.config?.hasErrorChecker?.(data);
        if (hasError) {
          throw hasError;
        }
        pipe.responseData = data;
        this.afterSuccess(config, pipe);
        config?.afterSuccess?.();
        const gdata = config?.transform ? config.transform(data) : data;
        this.afterSuccessTransform(config, pipe);
        resolve(gdata);
      }).catch(async (e) => {
        this.error(config, pipe, e);
        config?.error?.(e);
        if (config?.errorTransform) {
          e = await config.errorTransform(e);
        }
        try {
          e = await this.errorTransform(e);
        } catch (ee) {
          e = ee;
        }
        reject(e);
      }).finally(() => {
        this.finally(config, pipe);
        config?.finally?.();
      });
    });
  }
}
export {
  Fetcher
};
//# sourceMappingURL=Fetcher.js.map
